import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  template: `
    <div class="forbidden-container">
      <h1>Access Denied</h1>
      <p>You are not authorized to use this application on account: {{accountName}}.</p>
      <p>Try logging into a different Twitch account if the account above is incorrect. Do so via Twitch then return to this website.</p>
    </div>
  `,
  styles: [`
    .forbidden-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      text-align: center;
    }
  `]
})
export class ForbiddenComponent {
    constructor(private router: Router) {
        const navigation = this.router.getCurrentNavigation();
        console.log('navigation ctor', navigation)
        this.accountName = navigation?.extras.state?.['twitchLogin'] ?? 'UNKNOWN_NAME';
    }

    public accountName?: string;
}
